/***************************************************************************************************
** handleStaleAppVersion
***************************************************************************************************/

export default function handleStaleAppVersion(response) {
  const serverVersion = response.headers.get("X-App-Version");

  if (serverVersion && serverVersion !== window.KINN_PORTALS_VERSION) {
    if (sessionStorage.getItem("_kinn_version_reload") === serverVersion) return false;

    sessionStorage.setItem("_kinn_version_reload", serverVersion);
    window.location.reload();
    return true;
  }

  return false;
}
